<template>
    <div
            class="block"
            :style="{ backgroundColor , color }"
    >
        <p class="text">{{ name }}</p>
    </div>
</template>

<script>
    export default {
        name: 'Block',
        props: {
            name: String,
            url: String,
            created: String,
            backgroundColor: String,
            color: String,
        }
    }
</script>

<style>
    .block {
        position: relative;
        height: 250px;
    }

    .block:hover {
        opacity: 0.9;
    }

    .block .text {
        position: absolute;
        font-size: 30px;
        margin-top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center; /** Y-axis align **/
        justify-content: center; /** X-axis align **/
    }
</style>
